import { useState, useEffect, ReactNode } from "react";

/**
 * Wrapper that only renders children on the client side.
 * During SSR, renders nothing (or an optional fallback).
 * Use for components that depend on browser APIs (localStorage, window, tRPC hooks).
 */
export default function ClientOnly({
  children,
  fallback = null,
}: {
  children: ReactNode;
  fallback?: ReactNode;
}) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) return <>{fallback}</>;
  return <>{children}</>;
}
